import script from "./add-site-manager.vue?vue&type=script&setup=true&lang=ts"
export * from "./add-site-manager.vue?vue&type=script&setup=true&lang=ts"

import "./add-site-manager.vue?vue&type=style&index=0&id=169d07ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-169d07ae"]])

export default __exports__